module.exports = __webpack_public_path__ + "images/98eca842d67938ada81b6c1fefc11928.png";